import { v4 as uuidv4 } from 'uuid';

export const generateQuestionKey = ({
  prefix = '',
  removeDashes = false,
  lettersOnly = false,
}: Partial<{ prefix?: string; removeDashes?: boolean; lettersOnly?: boolean }> = {}) => {
  let uuid = '';
  if (lettersOnly) {
    const characters = 'abcdefghijklmnopqrstuvwxyz';
    const charactersLength = characters.length;
    for (let i = 0; i < 12; i++) {
      uuid += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
  } else {
    uuid = uuidv4();
  }

  return `${prefix}${removeDashes ? uuid.replaceAll('-', '') : uuid}`;
};
